import React from 'react';
import { AlignItems, CFlex, JustifyContent } from '@dark-portal/react-components';

import './Loader.sass';

export const Loader = (): React.JSX.Element => {
  return (
    <CFlex
      fullWidth={true}
      fullHeight={true}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
    >
      <div className="loader triangle">
        <svg viewBox="0 0 86 80">
          <polygon points="43 8 79 72 7 72"></polygon>
        </svg>
      </div>
    </CFlex>
  );
};
